export const SuccessMessage = "SUCCESS_MESSAGE";
export const ServiceUnavailable = "SERVICE_UNAVAILABLE";
